<template>
  <div class="websites">
    <h1>Nuovo Sito</h1>
      <div class="form">
        <div>
          <input type="text" name="name" placeholder="NOME" v-model="name">
        </div>
        <div>
          <input type="text" name="baseurl" placeholder="URL" v-model="baseurl">
        </div>
        <div>
          <input type="text" name="rule" placeholder="REGOLA" v-model="rule">
        </div>
        <div>
          <input type="checkbox" name="unformatthousands" placeholder="" v-model="unformatthousands"> ELIMINA SEPARATORE MIGLIAIA
        </div>
        <div>
          <input type="checkbox" name="addvat" placeholder="" v-model="addvat"> SITO IVA ESCLUSA
        </div>
        <div>
          <input type="checkbox" name="hidereport" placeholder="" v-model="hidereport"> NASCONDI DA REPORT
        </div>
        <div>
          <button class="app_btn" @click="addWebsite">Salva</button>
        </div>
      </div>
  </div>
</template>

<script>
import WebsitesService from '@/services/WebsitesService'
export default {
  name: 'NewWebsite',
  data () {
    return {
      name: '',
      baseurl: '',
      rule: '',
      unformatthousands: false,
      hidereport: false,
      addvat: false
    }
  },
  methods: {
    async addWebsite () {
      await WebsitesService.add({
        name: this.name,
        baseurl: this.baseurl,
        rule: this.rule,
        unformatthousands: this.unformatthousands,
        hidereport: this.hidereport,
        addvat: this.addvat
      })
      this.$router.push({ name: 'Websites' })
    }
  }
}
</script>
<style type="text/css">
.form input, .form textarea {
  width: 500px;
  padding: 10px;
  border: 1px solid #e0dede;
  outline: none;
  font-size: 12px;
}
.form div {
  margin: 20px;
}
.app_btn {
  background: #4d7ef7;
  color: #fff;
  padding: 10px 80px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  width: 100%;
  max-width: 500px;
  border: none;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/NewWebsite.vue